<template>
  <div>
    <!-- main-area -->
    <main class="fix">
      <!-- breadcrumb-area -->
      <section class="breadcrumb__area breadcrumb__bg">
        <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb__content">
                <h2 class="title">Alat Kelengkapan Dewan</h2>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">Profil</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Alat Kelengkapan Dewan</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div class="breadcrumb__shape">
          <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
        </div>
      </section>

      <section class="services__details-area py-3">
        <div class="container">
          <div class="services__details-wrap">
            <div class="row">
              
              <!-- Kolom Utama: Susunan Organisasi Anggota Badan -->
              <div class="col-70 order-0 order-lg-2">
                <div class="row">
                  <h6 class="mb-3 text-center fw-bold text-dark" style="font-size: 15px;">
                    Struktur Susunan Keanggotaan {{ badanLabel }}
                  </h6>

                  <div v-if="list_data.length > 0" class="struktur-organisasi-wrap w-100">
                    
                    <!-- LEVEL 1: KETUA (Tengah / Atas) -->
                    <div class="row justify-content-center gx-2 mb-1" v-if="ketuaList.length > 0">
                      <div class="col-auto text-center" v-for="d in ketuaList" :key="d.id_relasi || d.id" style="min-width: 140px; max-width: 170px;">
                        <div class="mini-dewan-card">
                          <div
                            class="mini-thumb shine-animate"
                            @click="selectData(d)"
                            data-bs-toggle="modal"
                            data-bs-target="#modalBadan"
                          >
                            <img
                              :src="getFoto(d)"
                              alt="Foto Ketua"
                              @error="$event.target.src='assets/img/user.png'"
                            />
                          </div>
                          <div class="mini-info mt-1">
                            <div class="mini-name fw-bold text-dark">{{ d.nama }}</div>
                            <div class="mini-role fw-bold text-warning">{{ d.jabatan_badan }}</div>
                            <div v-if="d.nama_fraksi || d.nama_partai" class="mini-sub text-muted">
                              {{ d.nama_fraksi || d.nama_partai }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- LEVEL 2: WAKIL KETUA & SEKRETARIS (Baris Tengah) -->
                    <div class="row justify-content-center gx-3 mb-1" v-if="wakilSekretarisList.length > 0">
                      <div class="col-auto text-center" v-for="d in wakilSekretarisList" :key="d.id_relasi || d.id" style="min-width: 140px; max-width: 170px;">
                        <div class="mini-dewan-card">
                          <div
                            class="mini-thumb shine-animate"
                            @click="selectData(d)"
                            data-bs-toggle="modal"
                            data-bs-target="#modalBadan"
                          >
                            <img
                              :src="getFoto(d)"
                              alt="Foto Wakil/Sekretaris"
                              @error="$event.target.src='assets/img/user.png'"
                            />
                          </div>
                          <div class="mini-info mt-1">
                            <div class="mini-name fw-bold text-dark">{{ d.nama }}</div>
                            <div class="mini-role fw-bold" :class="d.jabatan_badan && d.jabatan_badan.toLowerCase().includes('wakil') ? 'text-primary' : 'text-success'">
                              {{ d.jabatan_badan }}
                            </div>
                            <div v-if="d.nama_fraksi || d.nama_partai" class="mini-sub text-muted">
                              {{ d.nama_fraksi || d.nama_partai }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- LEVEL 3: ANGGOTA (Baris Bawah / Multi-kolom) -->
                    <div class="row justify-content-center gx-2 gy-2 mt-1" v-if="anggotaList.length > 0">
                      <div class="col-auto text-center mb-2" v-for="d in anggotaList" :key="d.id_relasi || d.id" style="min-width: 125px; max-width: 155px;">
                        <div class="mini-dewan-card">
                          <div
                            class="mini-thumb shine-animate"
                            @click="selectData(d)"
                            data-bs-toggle="modal"
                            data-bs-target="#modalBadan"
                          >
                            <img
                              :src="getFoto(d)"
                              alt="Foto Anggota"
                              @error="$event.target.src='assets/img/user.png'"
                            />
                          </div>
                          <div class="mini-info mt-1">
                            <div class="mini-name fw-bold text-dark">{{ d.nama }}</div>
                            <div class="mini-role text-secondary fw-bold">{{ d.jabatan_badan || 'Anggota' }}</div>
                            <div v-if="d.nama_fraksi || d.nama_partai" class="mini-sub text-muted">
                              {{ d.nama_fraksi || d.nama_partai }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <!-- Empty State -->
                  <div v-else class="text-center py-4">
                    <p class="text-muted small">Belum ada anggota yang terdaftar untuk badan/periode ini.</p>
                  </div>

                </div>
              </div>

              <!-- Sidebar: Pilihan Masa Jabatan & Daftar Badan -->
              <div class="col-30">
                <aside class="services__sidebar">
                  <div class="sidebar__widget sidebar__widget-two p-3">
                    
                    <!-- Filter Masa Jabatan -->
                    <div class="mb-3">
                      <label for="filterMasaJabatan" class="form-label fw-bold small">Pilih Masa Jabatan:</label>
                      <select
                        id="filterMasaJabatan"
                        class="form-select form-select-sm"
                        v-model="masa_jabatan_selected"
                        @change="onChangeMasaJabatan"
                      >
                        <option
                          v-for="m in list_masa_jabatan"
                          :key="m.id"
                          :value="m.id"
                        >
                          {{ m.label }}
                        </option>
                      </select>
                    </div>

                    <!-- Kategori Daftar Badan -->
                    <div class="sidebar__cat-list-two">
                      <ul class="list-wrap" v-if="list_badan.length > 0">
                        <li
                          v-for="b in list_badan"
                          :key="b.id"
                          :class="{ active: badan_id_selected === b.id }"
                        >
                          <a href="javascript:void(0)" @click="filterByBadan(b.id)" class="py-2" style="font-size: 13px;">
                            {{ b.nama }}
                            <small v-if="b.singkatan" class="ms-1 fw-bold">({{ b.singkatan }})</small>
                          </a>
                        </li>
                      </ul>
                      <div v-else class="py-3 text-center">
                        <small class="text-muted">Belum ada data badan.</small>
                      </div>
                    </div>

                  </div>
                </aside>
              </div>

            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- Modal Detail Anggota Badan -->
    <div class="modal fade" id="modalBadan" tabindex="-1" aria-labelledby="modalBadanLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content shadow-lg">
          <div class="modal-header text-white py-2 px-3">
            <h5 class="modal-title fs-6" id="modalBadanLabel">{{ form.nama }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Tutup"></button>
          </div>
          <div class="modal-body p-3">
            <div class="row">
              <!-- Foto -->
              <div class="col-md-5 text-center mb-3 mb-md-0">
                <img
                  :src="getFoto(form)"
                  alt="Foto Detail"
                  class="img-fluid rounded shadow-sm"
                  style="max-height: 260px; object-fit: cover;"
                  @error="$event.target.src='assets/img/user.png'"
                />
              </div>

              <!-- Info Detail -->
              <div class="col-md-7">
                <ul class="list-group list-group-flush" style="font-size: 13px;">
                  <li class="list-group-item d-flex justify-content-between py-1 px-2">
                    <strong>Jabatan DPRD:</strong>
                    <span>{{ form.jabatan_dprd }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between py-1 px-2">
                    <strong>Kedudukan Dalam Badan:</strong>
                    <span class="fw-bold text-primary">{{ form.jabatan_badan || 'Anggota' }} - {{ badanLabel }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between py-1 px-2" v-if="form.nama_fraksi && form.nama_fraksi !== '-'">
                    <strong>Unsur / Fraksi:</strong>
                    <span v-if="form.nama_fraksi === 'SEKWAN'">SEKWAN</span>
                    <span v-else>{{ form.nama_fraksi }} <small v-if="form.jabatan_fraksi && form.jabatan_fraksi !== '-'">({{ form.jabatan_fraksi }})</small></span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between py-1 px-2" v-if="form.nama_partai && form.nama_partai !== '-' && form.nama_partai !== 'Non-Partai'">
                    <strong>Partai:</strong>
                    <span>{{ form.nama_partai }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between py-1 px-2" v-if="form.komisi && form.komisi !== '-'">
                    <strong>Komisi:</strong>
                    <span>{{ form.komisi }} <small v-if="form.jabatan_komisi && form.jabatan_komisi !== '-'">({{ form.jabatan_komisi }})</small></span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between py-1 px-2" v-if="form.dapil && form.dapil !== '-'">
                    <strong>Daerah Pemilihan:</strong>
                    <span>{{ form.dapil }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between py-1 px-2" v-if="form.ttl && form.ttl !== '-'">
                    <strong>Tempat, Tanggal Lahir:</strong>
                    <span>{{ form.ttl }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between py-1 px-2" v-if="form.agama && form.agama !== '-'">
                    <strong>Agama:</strong>
                    <span>{{ form.agama }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between py-1 px-2" v-if="form.alamat && form.alamat !== '-'">
                    <strong>Alamat:</strong>
                    <span>{{ form.alamat }}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between py-1 px-2">
                    <strong>Masa Jabatan:</strong>
                    <span>{{ form.masa_jabatan_label }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'AlatDewan',

  data() {
    return {
      list_data: [],
      list_badan: [],
      list_masa_jabatan: [],
      badan_id_selected: '',
      masa_jabatan_selected: '',
      file_path: this.$store.state.URL_APP + "uploads/",

      form: {
        id: '',
        nama: '',
        jabatan_dprd: '-',
        jabatan_badan: 'Anggota',
        jabatan_fraksi: '',
        jabatan_komisi: '',
        nama_fraksi: '',
        nama_partai: '',
        komisi: '',
        dapil: '-',
        ttl: '-',
        agama: '-',
        alamat: '-',
        masa_jabatan_label: '-',
        file: '',
        is_simpeg: 0
      }
    };
  },

  computed: {
    badanLabel() {
      const selected = this.list_badan.find(b => b.id === this.badan_id_selected);
      if (!selected) return 'Badan';
      return selected.singkatan ? `${selected.nama} (${selected.singkatan})` : selected.nama;
    },

    ketuaList() {
      return this.list_data.filter(d => {
        const j = (d.jabatan_badan || '').toLowerCase();
        return j.includes('ketua') && !j.includes('wakil');
      });
    },

    wakilSekretarisList() {
      return this.list_data.filter(d => {
        const j = (d.jabatan_badan || '').toLowerCase();
        return j.includes('wakil') || j.includes('sekretaris') || j.includes('sekertaris');
      });
    },

    anggotaList() {
      return this.list_data.filter(d => {
        const j = (d.jabatan_badan || '').toLowerCase();
        return !j.includes('ketua') && !j.includes('wakil') && !j.includes('sekretaris') && !j.includes('sekertaris');
      });
    }
  },

  methods: {
    filterByBadan(id) {
      this.badan_id_selected = id;
      this.getAnggotaBadan();
    },

    onChangeMasaJabatan() {
      this.getListBadan();
    },

    getFoto(item) {
      if (!item || !item.file || item.file === 'null' || item.file === 'undefined') {
        return 'assets/img/user.png';
      }
      if (typeof item.file === 'string' && (item.file.startsWith('http://') || item.file.startsWith('https://'))) {
        return item.file;
      }
      if (item.is_simpeg) {
        return (this.$store.state.URL_APP_SIMPEG || 'https://server-egov.konaweselatankab.go.id/') + "uploads/" + item.file;
      }
      return this.file_path + item.file;
    },

    selectData(data) {
      this.form = {
        id: data.id,
        nama: data.nama,
        jabatan_dprd: data.jabatan_dprd || '-',
        jabatan_badan: data.jabatan_badan || 'Anggota',
        jabatan_fraksi: data.jabatan_fraksi || '',
        jabatan_komisi: data.jabatan_komisi || '',
        nama_fraksi: data.nama_fraksi || '',
        nama_partai: data.nama_partai || '',
        komisi: data.komisi || '',
        dapil: data.dapil || '-',
        ttl: data.ttl || '-',
        agama: data.agama || '-',
        alamat: data.alamat || '-',
        masa_jabatan_label: data.masa_jabatan_label || '-',
        file: data.file,
        is_simpeg: data.is_simpeg
      };
    },

    getListBadan() {
      fetch(this.$store.state.ADD_URL_BADAN + "view", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          masa_jabatan: this.masa_jabatan_selected
        })
      })
        .then(res => res.json())
        .then(data => {
          this.list_badan = data || [];
          if (this.list_badan.length > 0) {
            const exists = this.list_badan.find(b => b.id === this.badan_id_selected);
            if (!exists) {
              this.badan_id_selected = this.list_badan[0].id;
            }
          } else {
            this.badan_id_selected = '';
          }
          this.getAnggotaBadan();
        })
        .catch(err => console.error("Gagal ambil data badan:", err));
    },

    getAnggotaBadan() {
      if (!this.badan_id_selected) {
        this.list_data = [];
        return;
      }

      fetch(this.$store.state.ADD_URL_BADAN + "view_badan", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          badan_id: this.badan_id_selected,
          masa_jabatan: this.masa_jabatan_selected
        })
      })
        .then(res => res.json())
        .then(data => {
          this.list_data = data || [];
        })
        .catch(err => console.error("Gagal ambil anggota badan:", err));
    },

    getMasaJabatan() {
      fetch(this.$store.state.ADD_URL_MASA_JABATAN + "view", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data_ke: 1 })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_masa_jabatan = res_data.data || [];
          const masaDefault = this.list_masa_jabatan.find(
            m => m.label === "2024 - 2029"
          ) || this.list_masa_jabatan[0];

          if (masaDefault) {
            this.masa_jabatan_selected = masaDefault.id;
          }

          this.getListBadan();
        })
        .catch(err => console.error("Gagal ambil masa jabatan:", err));
    }
  },

  mounted() {
    this.getMasaJabatan();
  }
};
</script>

<style scoped>
.mini-dewan-card {
  padding: 4px;
  border-radius: 6px;
  transition: transform 0.2s ease;
}

.mini-dewan-card:hover {
  transform: translateY(-3px);
}

.mini-thumb {
  width: 80px;
  height: 95px;
  margin: 0 auto;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
}

.mini-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}

.mini-info {
  line-height: 1.2;
}

.mini-name {
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 2px;
}

.mini-role {
  font-size: 10px;
  line-height: 1.1;
  margin-bottom: 1px;
}

.mini-sub {
  font-size: 9px;
  line-height: 1.1;
  color: #64748b !important;
}
</style>